import React, { useState, useEffect } from "react";
import me from "./assets/me.jpg";
import Workex from "./Workex";
import "./Simple.css";
import Projectex from "./Projectex";
import email from "./assets/email.png";
import linkedin from "./assets/linkedin.png";
import github from "./assets/github.png";
import { Link } from "react-router-dom";
import content from "./content.json";

function Simple() {
  const [projects, setProjects] = useState([]); // State for storing GitHub projects
  const [isLoading, setIsLoading] = useState(true); // State for loading
  const excludedProjects = [
    "waterfall",
    "equi",
    "spectral-arctic-buoys",
    "interactive-timeline",
  ]
  // Fetch GitHub projects
  useEffect(() => {
    async function fetchProjects() {
      try {
        const response = await fetch("https://api.github.com/users/KamiV2/repos");
        if (!response.ok) {
          setProjects({});
        }
        const data = await response.json();
        let data_filtered = data.filter(proj => !excludedProjects.includes(proj.name));
        setProjects(data_filtered);
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchProjects();
  }, []);

  return (
    <div className="App">
      <div className="sim-columns">
        <div className="sim-column">
          <div className="sim-col-item">
            <div className="sim-col-header">{"Home > me.jpg"}</div>
            <div className="sim-col-content">
              <div className="sim-col-imgdiv">
                <img id="sim-me" src={me} alt="Karun" />
              </div>
            </div>
          </div>
          <div className="sim-col-item-fill">
            <div className="sim-col-header">{"Home > about.txt"}</div>
            <div className="sim-col-content" style={{ fontSize: "1.3vmin" }}>
              {content.about.map((p, i) => (
                <p key={i} dangerouslySetInnerHTML={{ __html: p }}></p>
              ))}
            </div>
          </div>
        </div>
        <div className="sim-column">
          <div className="sim-col-item-fill">
            <div className="sim-col-header">{"Home > projects.txt"}</div>
            <div className="sim-col-content">
              <div className="sim-projects">
                {isLoading ? (
                  <p>Loading projects...</p>
                ) : (
                  projects.map((project) => (
                    <Projectex
                      key={project.id}
                      title={project.name}
                      link={project.html_url}
                      desc={project.description || "No description provided."}
                      language={project.language || "N/A"}
                    />
                  ))
                )}
              </div>
            </div>
          </div>
          <div className="sim-col-item-fill">
            <div className="sim-col-header">{"Home > thesis.txt"}</div>
            <div className="sim-col-content">
              <div className="sim-thesis" style={{fontSize: "1.5vmin"}}>
                <p>For my senior thesis, I worked with <a href={content.thesis.advisorLink}>Prof. Siddhartha Jayanti</a> on machine-verifying the strong linearizability of the Jayanti-Tarjan union-find object, a concurrent randomized union-find data structure. The specification of the object, and the proof of its correctness, are written in TLA+ and span over 16000 lines, and required the introduction of novel modelling and proof techniques.</p>
                <p>My thesis was awarded departmental high honors, and the research recieved a $2400 grant under Dartmouth's Lovelace Scholars program. For this work, I was also awarded the Neukom Institute prize for outstanding undergraduate computational research (2nd place).</p>
                <p>You can view my work <a href={content.thesis.link}>here</a>.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="sim-column">
          <div className="sim-col-item-fill">
            <div className="sim-col-header">{"Home > work.txt"}</div>
            <div className="sim-col-content">
              <p>Here's a quick summary of my work experience.</p>
              <div className="sim-work">
                {content.work.map((w, idx) => (
                  <Workex
                    key={idx}
                    title={w.title}
                    company={w.company}
                    companyLink={w.companyLink}
                    dates={`[${w.dates}]`}
                    location={w.location}
                    description={w.description}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="sim-col-item">
            <div className="sim-col-header">{"Home > contact-me.txt"}</div>
            <div className="sim-col-content">
              <div className="contact-row">
                <img className="contact-icon" src={email} alt="email" />
                <p>
                  <a href="mailto:karun.ram.25@dartmouth.edu" target="_blank" rel="noreferrer">
                    Email
                  </a>{" "}
                  me!
                </p>
              </div>
              <div className="contact-row">
                <img className="contact-icon" src={linkedin} alt="linkedin" />
                <p>
                  My{" "}
                  <a href="https://www.linkedin.com/in/karun-ram" target="_blank" rel="noreferrer">
                    LinkedIn
                  </a>{" "}
                  profile
                </p>
              </div>
              <div className="contact-row">
                <img className="contact-icon" src={github} alt="github" />
                <p>
                  Check out my{" "}
                  <a href="https://www.github.com/KamiV2" target="_blank" rel="noreferrer">
                    GitHub
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="return-link">
        <Link to="/">Return to interactive version!</Link>
      </div>
    </div>
  );
}

export default Simple;
